import { Component, Input, input, output } from '@angular/core';
import { EDIT_MODE_MENU_ITEMS, EditMode, EditModeMenuItem } from '../editor-mode';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss'],
  imports: [MatIconModule, MatRippleModule, TranslateModule],
})
export class MainMenuComponent {
  readonly disabled = input(false);

  @Input() set editMode(value: EditMode) {
    this.buttons.forEach(button => {
      button.isActive = button.mode === value;
    });
  }

  readonly modeChanged = output<EditMode>();

  buttons: IMenuButtonModel[] = EDIT_MODE_MENU_ITEMS.map(button => ({
    ...button,
    isActive: false,
  }));

  setActiveMode(button: IMenuButtonModel) {
    if (this.disabled()) return;
    if (button.isActive) {
      button.isActive = false;
      this.modeChanged.emit(EditMode.None);
      return;
    }
    this.buttons.forEach(btn => {
      btn.isActive = btn === button;
    });
    this.modeChanged.emit(button.mode);
  }
}

export interface IMenuButtonModel extends EditModeMenuItem {
  isActive: boolean;
}
